/**
 * Horizontal legend for charts. Items shape: { label, color }.
 * Colors passed as raw hex — not bound to the theme system, because chart
 * palettes use graduated grays alongside the accent (see theme.chart in CLAUDE.md).
 */
export function ChartLegend({ items, className = "" }) {
  return (
    <div className={`flex flex-wrap items-center gap-4 ${className}`}>
      {items.map((item) => (
        <div
          key={item.label}
          className="flex items-center gap-1.5 text-[11px] text-text-secondary"
        >
          <span
            className="inline-block w-2.5 h-2.5 rounded-sm flex-shrink-0"
            style={{ backgroundColor: item.color }}
            aria-hidden="true"
          />
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
}
